<onyx-modal
  variant="right"
  [heading]="employee() ? (employee()! | onyxName) : undefined"
  [loading]="loading()"
  [(error)]="error"
  [gap]="0"
  [close$]="close$"
  (errorChange)="employee$.next()"
  (closeModal)="dialogRef.close()"
>
  <onyx-avatar
    image
    variant="user"
    [user]="employee()"
    [size]="60"
  ></onyx-avatar>

  <ng-container titleRightOptions>
    @if (employee(); as employee) {
      <app-unavailability-icon
        [unavailability]="employee.unavailability"
      ></app-unavailability-icon>
    }
  </ng-container>

  @let hasEdit = authStore.hasPermission('employees.edit');
  <ng-container headingButtons>
    @if (employee(); as employee) {
      @if (hasEdit) {
        <onyx-icon-button
          color="gray"
          variant="transparent"
          [size]="32"
          icon="edit-outlined"
          [circle]="true"
          [disabled]="!hasHierarchicalEdit()"
          onyxTooltip="labels.edit"
          (click)="hasHierarchicalEdit() ? edit() : null"
        ></onyx-icon-button>
      }

      <onyx-icon-button
        color="gray"
        variant="transparent"
        [size]="32"
        icon="telephone-outlined"
        [circle]="true"
        onyxTooltip="labels.call"
        (click)="ActionHelper.makeCall(employee.phone)"
      ></onyx-icon-button>

      @if (options()?.length) {
        <onyx-icon-button
          color="gray"
          variant="transparent"
          [size]="32"
          icon="options-vertical-filled"
          [circle]="true"
          [disabled]="!options()?.length"
          [onyxDropdownOptions]="options()"
          [onyxDropdownDisabled]="!options()?.length"
          (onyxDropdownSelectedValueChange)="$event.value?.()"
          onyxTooltip="labels.options"
          (click)="$event.stopPropagation()"
        ></onyx-icon-button>
      }
    }
  </ng-container>

  <div description class="description">
    @if (employee()?.roles; as roles) {
      @for (role of roles; track role.value) {
        <onyx-badge [color]="role.color">
          {{ `${DictionaryCode.EMPLOYEE_ROLE}.${role.value}` | translate }}
        </onyx-badge>
      }
    }
  </div>

  @if (employee(); as employee) {
    <div class="container">
      <section>
        <onyx-information-row label="labels.status">
          <app-employee-status
            [employee]="employee"
            [displayStatus]="true"
          ></app-employee-status>
        </onyx-information-row>

        <onyx-information-heading>
          {{ 'labels.contactData' | translate }}
        </onyx-information-heading>

        <onyx-information-list>
          <onyx-information-row label="labels.phone">
            {{ employee.phone | onyxPhone }}
          </onyx-information-row>

          <onyx-information-row label="labels.email">
            {{ employee.email }}
          </onyx-information-row>
        </onyx-information-list>
      </section>

      <section>
        <onyx-information-heading>
          {{ 'labels.activity' | translate }}
        </onyx-information-heading>

        <onyx-information-list>
          <onyx-information-row label="labels.joinDate">
            @if (employee.joinedAt) {
              {{ employee.joinedAt | onyxDate: 'time-date' }}
            } @else {
              -
            }
          </onyx-information-row>
        </onyx-information-list>
      </section>

      <div class="wrapper">
        <onyx-chips
          left
          [chips]="sections()"
          variant="secondary"
          [single]="true"
          [gap]="8"
          [(activeValues)]="section"
        ></onyx-chips>

        @switch (section()[0]) {
          @case (EmployeeModalSection.ASSIGNED_VEHICLES) {
            <div class="vehicles">
              @if (
                hasEdit && employee.status.value !== EmployeeStatus.ARCHIVED
              ) {
                <onyx-button
                  class="edit-button"
                  variant="outlined"
                  [size]="32"
                  leftIcon="edit-outlined"
                  [disabled]="!hasHierarchicalEdit()"
                  (click)="hasHierarchicalEdit() ? assignVehicles() : null"
                >
                  {{ 'labels.edit' | translate }}
                </onyx-button>

                <!-- N/A: Add search -->
              }

              <onyx-table
                [data]="assignedVehicles()"
                [columns]="EMPLOYEES_ASSIGNED_VEHICLES_LIST_COLUMNS"
                [loading]="loading()"
                [tableShadow]="false"
                [rowSize]="48"
                [notFound]="ASSIGNED_VEHICLES_NOT_FOUND"
                [(pagination)]="pagination"
                (rowClick)="openFleetModal($event.item)"
              ></onyx-table>
            </div>
          }
          @case (EmployeeModalSection.PLANNED_UNAVAILABILITIES) {
            <app-unavailabilities
              [employee]="employee"
              [enabled]="hasHierarchicalEdit()"
              [showAdd]="hasEdit"
            ></app-unavailabilities>
          }
        }
      </div>
    </div>
  }
</onyx-modal>
